import { JWT_KEY } from "Auth/Models/AuthConstants";
import { getApiV1AuthUserinfoQueryKey } from "Infrastructure/Api/generated/@tanstack/react-query.gen";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import {
	clearClientEpochs,
	writeStoredSelectedClient,
} from "Shared/Client/selectedClientStorage";
import { type QueryClient, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

export function useSignOut() {
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	return () => {
		processSignOut(queryClient);
		navigate(AppRouting.SignIn.path(), { replace: true });
	};
}

export function processSignOut(queryClient: QueryClient) {
	localStorage.removeItem(JWT_KEY);
	writeStoredSelectedClient(null);
	// Wipe the per-client epoch counters so a re-sign-in doesn't look like a
	// boundary crossing for the next user.
	clearClientEpochs();
	// Remove (not invalidate) so the cached `data` is wiped — otherwise
	// UnauthenticatedRoute would still see stale userinfo data and ping-pong
	// the user back to /dashboard, triggering a refetch storm.
	queryClient.removeQueries({ queryKey: getApiV1AuthUserinfoQueryKey() });
}
